import { Tabs, TabPanel, useTabs } from '@/components/ui/Tabs';
import { DataRulesTab } from './DataRulesTab';
import { TeamsTab } from './TeamsTab';
import { DataRolesTab } from './DataRolesTab';
import { AssignmentsTab } from './AssignmentsTab';

// ─── Tab Definitions ────────────────────────────────────────────────────────

const TABS = [
  { id: 'data-rules', label: 'Data Rules' },
  { id: 'data-roles', label: 'Data Roles' },
  { id: 'teams', label: 'Teams' },
  { id: 'assignments', label: 'Assignments' },
];

// ─── Main Component ─────────────────────────────────────────────────────────

/**
 * DataAuthorizationPage — Container with tabs for Teams, Data Roles, and Assignments.
 * Requirements: REQ-5.1
 */
export function DataAuthorizationPage() {
  const { activeTab, onChange } = useTabs('data-rules');

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Data Authorization
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Manage teams, data roles, and team-to-role assignments to control data visibility.
        </p>
      </div>

      {/* Tabs */}
      <Tabs tabs={TABS} activeTab={activeTab} onChange={onChange} />

      <TabPanel tabId="data-rules" activeTab={activeTab}>
        <DataRulesTab />
      </TabPanel>

      <TabPanel tabId="data-roles" activeTab={activeTab}>
        <DataRolesTab />
      </TabPanel>

      <TabPanel tabId="teams" activeTab={activeTab}>
        <TeamsTab />
      </TabPanel>

      <TabPanel tabId="assignments" activeTab={activeTab}>
        <AssignmentsTab />
      </TabPanel>
    </div>
  );
}
